import React from 'react';
import Breadcrumbs from "../components/Breadcrumbs";
import ShopArea from "../components/ShopArea";
import Modal from "../components/Modal";
import {Helmet} from "react-helmet";

const Catalog = () => {
    return (
        <div>
            <Helmet>
                <meta charSet="utf-8"/>
                <title>Каталог - Holz-City</title>
                <meta
                    name="description"
                    content="Высококачественные пиломатериалы для строительства, отделки и ремонта."
                />
            </Helmet>
            <Breadcrumbs/>
            <ShopArea/>
            <Modal/>
        </div>
    );
};

export default Catalog;